export default __webpack_public_path__ + "static/media/cad_other.f7aecb73.svg";